import React from 'react'
import PropTypes from 'prop-types'
import { Text } from '../../../constants/TextConstants'
import { StyledBqSelect, StyledBqCheckbox, StyledBqOption } from './styles'

/**
 * @typedef {Object} UsersAdvancedFiltersSelectProps
 * @property {string} name
 * @property {string[]} value
 * @property {string[]| undefined} options
 * @property {string} label
 * @property {boolean | undefined} disabled
 * @property {string | undefined} placeholder
 * @property {(event: import("@beeq/core").BqSelectCustomEvent<{value: string | number | string[]; item: HTMLBqOptionElement;}>) => void} onSelect
 * @property {(event: import("@beeq/core").BqSelectCustomEvent<HTMLBqSelectElement>) => void} onBlur
 */

/**
 * @param {UsersAdvancedFiltersSelectProps} props
 * @returns {import('react').ReactElement}
 */
export default function UsersAdvancedFiltersSelect({
  name,
  value,
  options,
  label,
  disabled = false,
  placeholder = Text.UsersAdvancedFiltersUserSelectPlaceholder,
  onSelect,
  onBlur
}) {
  return (
    <StyledBqSelect
      name={name}
      value={JSON.stringify(value)}
      multiple
      disableClear
      placeholder={placeholder}
      disabled={disabled}
      onBqSelect={onSelect}
      onBqBlur={onBlur}
      data-testid={`advanced-search-filter-select-${name}`}
    >
      <label className="caption" slot="label">{label}</label>
      <label className="caption" slot="label" data-testid={`advanced-search-filter-selected-${label}`}>
        ({value.length})&nbsp;{Text.UsersAdvancedFiltersUserLabelSelected}
      </label>
      {options?.map((option) => (
        <StyledBqOption key={option} value={option}>
          <StyledBqCheckbox name='name' checked={value.includes(option)} value={option} />
          {option}
        </StyledBqOption>
      ))}
    </StyledBqSelect>
  )
}

UsersAdvancedFiltersSelect.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  options: PropTypes.arrayOf(PropTypes.string.isRequired),
  placeholder: PropTypes.string,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired
}
